import type { LucideIcon, LucideProps } from "lucide-react";

import React from "react";

const ShopifyIcon: LucideIcon = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ color = "currentColor", size = 24, className = "", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M15.4864 3.54582C15.4864 3.54582 15.238 3.61678 14.83 3.74097C14.759 3.51033 14.6526 3.24422 14.5106 2.96036C14.0494 2.07332 13.3575 1.59431 12.5414 1.59431C12.4882 1.59431 12.4349 1.59431 12.364 1.61205C12.3462 1.57657 12.3108 1.55883 12.293 1.52335C11.9382 1.13304 11.4769 0.955635 10.927 0.973376C9.8625 1.00886 8.79804 1.77172 7.94648 3.13777C7.34328 4.09578 6.88202 5.30217 6.75783 6.24244C5.53371 6.615 4.68214 6.88112 4.6644 6.89886C4.04346 7.09401 4.02572 7.11175 3.95476 7.6972C3.84831 8.14072 2.23389 20.6481 2.23389 20.6481L15.6461 22.9722V3.51033C15.5751 3.52807 15.5219 3.52807 15.4864 3.54582ZM12.3817 4.50383C11.6721 4.71672 10.8915 4.96509 10.1286 5.19572C10.3415 4.3619 10.7673 3.52807 11.264 2.9781C11.4592 2.78295 11.7253 2.55232 12.0269 2.41039C12.3285 3.04907 12.3995 3.91838 12.3817 4.50383ZM10.9447 1.68301C11.1931 1.68301 11.406 1.73624 11.5834 1.84268C11.2995 1.98461 11.0157 2.21524 10.7495 2.48136C10.0754 3.20874 9.5609 4.34416 9.34801 5.42636C8.70934 5.62151 8.07066 5.81666 7.48521 5.99407C7.85777 4.30868 9.29479 1.73624 10.9447 1.68301ZM8.86901 11.4405C8.93997 12.576 11.9382 12.8243 12.1156 15.5032C12.2398 17.6144 10.9979 19.0514 9.20608 19.1579C7.04169 19.2998 5.85304 18.0224 5.85304 18.0224L6.31431 16.0709C6.31431 16.0709 7.50295 16.9757 8.46096 16.9048C9.0819 16.8693 9.31253 16.3548 9.29479 16C9.20608 14.5097 6.75783 14.5984 6.59816 12.1502C6.45624 10.11 7.80455 8.03428 10.785 7.83913C11.9382 7.76816 12.5236 8.05202 12.5236 8.05202L11.8495 10.6067C11.8495 10.6067 11.0866 10.2519 10.1818 10.3229C8.86901 10.4116 8.85127 11.2454 8.86901 11.4405ZM13.0914 4.29094C13.0914 3.75871 13.0204 2.99585 12.772 2.35717C13.5881 2.51684 13.9784 3.42163 14.1558 3.9716C13.8365 4.0603 13.4817 4.16675 13.0914 4.29094Z"
          fill={color}
        />
        <path
          d="M16.0898 22.9011L21.6605 21.5173C21.6605 21.5173 19.2655 5.31983 19.2477 5.21339C19.23 5.10694 19.1413 5.03598 19.0526 5.03598C18.9639 5.03598 17.4027 5.00049 17.4027 5.00049C17.4027 5.00049 16.4447 4.07796 16.0898 3.72314V22.9011Z"
          fill={color}
        />
      </svg>
    );
  },
);

ShopifyIcon.displayName = "ShopifyIcon";

export default ShopifyIcon;
